<template>
  <div>
    <DataTable
      v-model:filters="rowFilters"
      v-model:expandedRows="expandedRows"
      :value="items"
      :row-hover="true"
      :loading="loading"
      :paginator="true"
      :rows="10"
      :scrollable="true"
      :lazy="true"
      :totalRecords="total"
      :rowsPerPageOptions="[10, 25, 50]"
      filterDisplay="row"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      currentPageReportTemplate="Memuat {first} dari {last} data dari total {totalRecords}"
      class="p-datatable-sm"
      @page="onPage($event)"
      @sort="onSort($event)"
      @filter="onFilter($event)"
    >
      <template #empty>
        <div class="text-center">Tidak ada data.</div>
      </template>
      <template #loading>
        <div class="text-center">Memuat data, harap tunggu...</div>
      </template>
      <template v-if="hasHeader" #header>
        <slot name="header"></slot>
      </template>
      <slot name="columns"></slot>
      <template #expansion="details">
        <DataTable
          :value="details.data.details"
          :scrollable="true"
          class="p-datatable-sm"
          showGridlines
        >
          <template #empty>
            <div class="text-center">Tidak ada data.</div>
          </template>
          <template #loading>
            <div class="text-center">Memuat data, harap tunggu...</div>
          </template>
          <Column
            field="item_sku"
            header="SKU"
            style="min-width: 8rem; background-color: #f8f9fa"
          />
          <Column
            field="item_barcode"
            header="Barcode"
            style="min-width: 8rem; background-color: #f8f9fa"
          />
          <Column
            field="item_name"
            header="Deskripsi"
            style="min-width: 12rem; background-color: #f8f9fa"
          />
          <Column
            field="qty"
            header="QTY (PCS)"
            style="
              min-width: 8rem;
              justify-content: flex-end;
              background-color: #f8f9fa;
            "
          >
          </Column>

          <Column
            field="price"
            header="Harga (/Satuan)"
            style="min-width: 10rem; justify-content: flex-end"
          >
            <template #body="slotProps">
              <span style="text-align: right">
                {{ formatCurrency(slotProps.data.price || 0) }}
              </span>
            </template>
          </Column>

          <!-- <Column
            field="price_1"
            header="HARGA_1 (/SATUAN)"
            style="min-width: 10rem; justify-content: flex-end;"
          >
            <template #body="slotProps">
              <span style="text-align: right">
                {{ formatCurrency(slotProps.data.price_1) }}
              </span>
            </template>
          </Column> -->

          <Column
            field="disc"
            header="disc"
            style="min-width: 8rem; justify-content: flex-end"
          >
            <template #body="slotProps">
              {{ `${slotProps.data.disc || 0}%` }}
            </template>
          </Column>
          <Column
            field="disc_value"
            header="disc value"
            style="min-width: 8rem; justify-content: flex-end"
          >
            <template #body="slotProps">
              {{ formatCurrency(slotProps.data.disc_value) }}
            </template>
          </Column>
          <Column
            field="dpp"
            header="Jumlah"
            style="
              min-width: 12rem;
              max-width: 12rem;
              justify-content: flex-end;
              background-color: #f8f9fa;
            "
          >
            <template #body="slotProps">
              {{ formatCurrency(slotProps.data.dpp) }}
            </template>
          </Column>
          <!-- <Column
            field="price"
            header="Harga Net"
            style="
              min-width: 12rem;
              max-width: 12rem;
              background-color: #f8f9fa;
            "
          >
            <template #body="slotProps">
              {{ formatCurrency(slotProps.data.price) }}
            </template>
          </Column> -->

          <template #footer>
            <table class="flex justify-content-end">
              <tr>
                <td width="100%">
                  <table class="justify-content-end text-700">
                    <tr>
                      <td>GRAND TOTAL</td>
                      <td class="text-right">
                        {{
                          formatCurrency(
                            (details.data.dpp || 0) -
                              (details.data.return_value || 0)
                          )
                        }}
                      </td>
                    </tr>

                    <!-- CASH -->
                    <tr v-if="details.data.member_1 == ''">
                      <td>PAY CASH</td>
                      <td style="width: 150px" class="text-right">
                        {{ formatCurrency(details.data.payment_1 || 0) }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        details.data.member_2 != null &&
                        details.data.member_2 == ''
                      "
                    >
                      <td>PAY CASH</td>
                      <td style="width: 150px" class="text-right">
                        {{ formatCurrency(details.data.payment_2 || 0) }}
                      </td>
                    </tr>

                    <!-- CREDIT -->
                    <tr
                      v-if="
                        details.data.member_1?.toLowerCase() == 'bc' ||
                        details.data.member_1?.toLowerCase() == 'cm'
                      "
                    >
                      <td>PAY CREDIT</td>
                      <td class="text-right">
                        {{ formatCurrency(details.data.payment_1 || 0) }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        details.data.member_2 != null &&
                        (details.data.member_2.toLowerCase() == 'bc' ||
                          details.data.member_2.toLowerCase() == 'cm')
                      "
                    >
                      <td>PAY CREDIT</td>
                      <td class="text-right">
                        {{ formatCurrency(details.data.payment_2 || 0) }}
                      </td>
                    </tr>

                    <!-- DEBIT -->
                    <tr
                      v-if="
                        details.data.member_1?.toLowerCase() == 'db' ||
                        details.data.member_1?.toLowerCase() == 'dm'
                      "
                    >
                      <td>PAY DEBIT</td>
                      <td class="text-right">
                        {{ formatCurrency(details.data.payment_1 || 0) }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        details.data.member_2 != null &&
                        (details.data.member_2.toLowerCase() == 'db' ||
                          details.data.member_2.toLowerCase() == 'dm')
                      "
                    >
                      <td>PAY DEBIT</td>
                      <td class="text-right">
                        {{ formatCurrency(details.data.payment_2 || 0) }}
                      </td>
                    </tr>

                    <!-- FLASH -->
                    <tr v-if="details.data.member_1?.toLowerCase() == 'fs'">
                      <td>PAY FLASH</td>
                      <td class="text-right">
                        {{ formatCurrency(details.data.payment_1 || 0) }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        details.data.member_2 != null &&
                        details.data.member_2.toLowerCase() == 'fs'
                      "
                    >
                      <td>PAY FLASH</td>
                      <td class="text-right">
                        {{ formatCurrency(details.data.payment_2 || 0) }}
                      </td>
                    </tr>

                    <!-- QRIS -->
                    <tr
                      v-if="
                        details.data.member_1?.toLowerCase() == 'qb' ||
                        details.data.member_1?.toLowerCase() == 'qm'
                      "
                    >
                      <td>PAY QRIS</td>
                      <td class="text-right">
                        {{ formatCurrency(details.data.payment_1 || 0) }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        details.data.member_2 != null &&
                        (details.data.member_2.toLowerCase() == 'qb' ||
                          details.data.member_2.toLowerCase() == 'qm')
                      "
                    >
                      <td>PAY QRIS</td>
                      <td class="text-right">
                        {{ formatCurrency(details.data.payment_2 || 0) }}
                      </td>
                    </tr>

                    <!-- VOUCHER -->
                    <tr v-if="details.data.member_1?.toLowerCase() == 'vc'">
                      <td>PAY VOUCHER</td>
                      <td class="text-right">
                        {{ formatCurrency(details.data.payment_1 || 0) }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        details.data.member_2 != null &&
                        details.data.member_2.toLowerCase() == 'vc'
                      "
                    >
                      <td>PAY VOUCHER</td>
                      <td class="text-right">
                        {{ formatCurrency(details.data.payment_2 || 0) }}
                      </td>
                    </tr>

                    <tr>
                      <td>KEMBALIAN</td>
                      <td class="text-right">
                        {{
                          details.data.dpp == 0 &&
                          details.data.return_value != 0
                            ? formatCurrency(
                                -1 * (details.data.return_value || 0)
                              )
                            : formatCurrency(details.data.cash_return || 0)
                        }}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </template>
        </DataTable>
      </template>
    </DataTable>
  </div>
</template>

<script>
import { formatCurrency } from '@/helpers/index'

export default {
  props: {
    items: {
      type: Array,
      default() {
        return []
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
    },
    gridOptions: {
      type: Object,
      default() {
        return {}
      },
    },
    filters: {
      type: Object,
      default() {
        return {}
      },
    },
    hasHeader: {
      type: Boolean,
      defaut: false,
    },
  },
  data() {
    return {
      expandedRows: [],
      rowFilters: this.filters,
      options: this.gridOptions,
    }
  },

  methods: {
    initFilters() {
      this.rowFilters = this.$props.filters
      this.onFilter()
    },
    formatCurrency(val) {
      return formatCurrency(val, 0, 0)
    },
    onPage(e) {
      e.page = e.page + 1
      e.sortField = this.options.sortField
      e.sortOrder = this.options.sortOrder
      this.options = e
      this.options.filters = this.rowFilters
      this.loadData()
    },
    onSort(e) {
      this.options = e
      this.loadData()
    },
    onFilter() {
      this.options.filters = this.rowFilters
      this.options.page = 1
      this.loadData()
    },
    loadData() {
      this.$emit('request', this.options)
    },
  },
}
</script>
